import React from 'react';
import { updateTicketStatusAPI, deleteTicketAPI } from '../../../utils/APIs/ticketsApis';
import { toast } from 'react-toastify';
import { FiTrash2, FiExternalLink } from 'react-icons/fi';

const TicketsTable = ({ data, page, limit, refreshData }) => {

    const handleStatusChange = async (id, newStatus) => {
        try {
            const res = await updateTicketStatusAPI(id, newStatus);
            if (res.data.success) {
                toast.success("Ticket status updated");
                refreshData();
            }
        } catch (error) {
            toast.error("Failed to update status");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this ticket?")) {
            try {
                const res = await deleteTicketAPI(id);
                if (res.data.success) {
                    toast.success("Ticket deleted");
                    refreshData();
                }
            } catch (error) {
                toast.error("Failed to delete ticket");
            }
        }
    };

    return (
        <div className="quote-table-wrapper">
            <table className="quote-table">
                <thead>
                    <tr>
                        <th className="td-sr">Sr.</th>
                        <th>Ticket ID</th>
                        <th>Client</th>
                        <th>Booking</th>
                        <th>Issue</th>
                        <th>Attachment</th>
                        <th>Status</th>
                        <th>Raised At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan="9" className="no-data">No tickets found</td>
                        </tr>
                    ) : (
                        data.map((ticket, index) => (
                            <tr key={ticket._id}>
                                <td className="td-sr">{(page - 1) * limit + index + 1}</td>
                                <td>{ticket._id.slice(-6).toUpperCase()}</td>
                                <td>
                                    <div className="d-flex flex-column">
                                        <span className="fw-bold">
                                            {typeof ticket.clientId === 'object' ? (ticket.clientId?.username || ticket.clientId?.name || 'N/A') : ticket.clientId || 'N/A'}
                                        </span>
                                        {typeof ticket.clientId === 'object' && ticket.clientId?.email && (
                                            <small className="text-muted">{ticket.clientId?.email}</small>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    {typeof ticket.bookingId === 'object' ? (ticket.bookingId?.veroaBookingId || 'N/A') : ticket.bookingId || 'N/A'}
                                </td>
                                <td title={ticket.issue}>
                                    <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {ticket.issue}
                                    </div>
                                </td>
                                <td>
                                    {ticket.attachment ? (
                                        <a href={ticket.attachment} target="_blank" rel="noopener noreferrer" className="btn-view">
                                            <FiExternalLink /> View
                                        </a>
                                    ) : '-'}
                                </td>
                                <td>
                                    <select 
                                        className={`status-select status-${ticket.status.replace(' ', '-')}`}
                                        value={ticket.status}
                                        onChange={(e) => handleStatusChange(ticket._id, e.target.value)}
                                    >
                                        <option value="open">Open</option>
                                        <option value="in progress">In Progress</option>
                                        <option value="closed">Closed</option>
                                    </select>
                                </td>
                                <td>{new Date(ticket.createdAt).toLocaleDateString('en-GB')}</td>
                                <td>
                                    <button className="btn-delete" onClick={() => handleDelete(ticket._id)}>
                                        <FiTrash2 />
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TicketsTable;
